import { PatchCustomersCurrentApiResponse } from 'core_main/api/customers/types';
import {
  DescribeCustomerParametersAttributes,
  DescribeCustomerCallbackResponse,
} from './types';

// taken from `web` for now
// TODO: We should consolidate string validators into an npm package lib-<<something>>
// so the backend and frontend can share the same validators from the same place
// https://kustomer.atlassian.net/browse/KDEV-72154
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = (email: string): boolean => EMAIL_REGEX.test(email);

export const formatAttributes = (
  attributes?: DescribeCustomerParametersAttributes,
) => {
  if (!attributes) return {};

  const entries = Object.entries(attributes);

  return entries.reduce((acc, val) => {
    const key = val[0] as keyof DescribeCustomerParametersAttributes;
    const value = val[1] as [];

    let values;

    if (key === 'phones' || key === 'sharedPhones') {
      values = value.map((val) => ({
        phone: val,
      }));
    }

    if ((key === 'emails' || key === 'sharedEmails') && Array.isArray(value)) {
      values = value
        .filter((val) => typeof val === 'string')
        .filter(isValidEmail)
        .map((val) => ({
          email: val,
        }));
    }

    acc[key] = values || value;

    return acc;
  }, {});
};

export const createDescribeCustomerCallbackResponse = (
  response: PatchCustomersCurrentApiResponse,
): DescribeCustomerCallbackResponse => {
  const { attributes, id } = response.data;
  const { custom } = attributes;

  const sharedEmails = attributes.sharedEmails?.map((val) => val.email);

  const sharedPhones = attributes.sharedPhones?.map((val) => val.phone);

  const sharedSocials = attributes.sharedSocials?.map((val) => ({
    username: val.username,
    type: val.type,
  }));

  return {
    customerId: id,
    custom,
    sharedEmails,
    sharedPhones,
    sharedSocials,
    emails: sharedEmails,
    phones: sharedPhones,
    socials: sharedSocials,
  };
};
